import { create } from 'zustand';

interface NewOrderState {
  newOrderIds: string[];
  setNewOrderIds: (ids: string[]) => void;
  removeNewOrderId: (id: string) => void;
  clearAll: () => void;
}

export const useNewOrderStore = create<NewOrderState>((set) => ({
  newOrderIds: [],
  setNewOrderIds: (ids) => set({ newOrderIds: ids }),
  removeNewOrderId: (id) =>
    set((state) => ({
      newOrderIds: state.newOrderIds.filter((orderId) => orderId !== id),
    })),
  clearAll: () => set({ newOrderIds: [] }),
}));
